<template>
    <v-container class="app-background-color pa-0" fill-height fluid>
        <v-row class="fill-height" justify="center" no-gutters>
            <v-col align-self="start" cols="12">
                <system-header title=""></system-header>
            </v-col>
            <v-col align-self="start" class="text-center" cols="12">
                <div class="display-1 font-weight-light mb-3">Oh No!</div>
                <div class="body-1">It looks like your web browser is not
                    compatible with fitt.
                    <br>
                    Please download one of the
                    following browsers and open the link again.
                </div>
                <div style="margin-top: 50px;">
                    <v-row justify="center">
                        <v-col cols="auto">
                            <div @click="goTo('https://www.google.com/chrome/')" v-ripple>
                                <div class="d-flex justify-center" style="width: 100%;">
                                    <v-img max-width="80"
                                           src="@/assets/logo_chrome.svg"
                                           style="cursor: pointer;"
                                    ></v-img>
                                </div>
                            </div>
                            <div class="text-center mt-3">Google Chrome</div>
                        </v-col>
                        <v-col cols="auto">
                            <div @click="goTo('https://www.mozilla.org/en-US/firefox/new/')" v-ripple>
                                <div class="d-flex justify-center" style="width: 100%;">
                                    <v-img max-width="80"
                                           src="@/assets/logo_firefox.svg"
                                           style="cursor: pointer;"
                                    ></v-img>
                                </div>
                            </div>
                            <div class="text-center mt-3">Mozilla Firefox</div>
                        </v-col>
<!--                        <v-col cols="auto" v-if="isOnMac()">-->
<!--                            <div @click="goTo('https://www.apple.com/lae/safari/')" v-ripple>-->
<!--                                <div class="d-flex justify-center" style="width: 100%;">-->
<!--                                    <v-img max-width="80"-->
<!--                                           src="@/assets/logo_safari.svg"-->
<!--                                           style="cursor: pointer;"-->
<!--                                    ></v-img>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="text-center mt-3">Apple Safari</div>-->
<!--                        </v-col>-->
                    </v-row>
                </div>
                <div style="margin: 70px 0 20px 0;">
                    <v-row justify="center">
                        <v-divider color="lightgray" style="max-width: 800px;"></v-divider>
                    </v-row>
                </div>
                <div class="font-weight-light mb-4">
                    Alternatively you can download the fitt
                    app for any of the following platforms
                </div>
                <v-row justify="center" no-gutters>
                    <v-col class="mr-2" cols="auto">
                        <div @click="downloadApp('web01osx')"
                             class="pa-3"
                             style="border-radius: 10px; cursor: pointer;"
                             v-ripple
                        >
                            <v-img contain
                                   height="80"
                                   src="/img/icons/platforms/apple.svg"
                                   width="80"
                            ></v-img>
                        </div>
                        <div class="text-center mt-3">Mac OS</div>
                    </v-col>
                    <v-col class="mx-12" cols="auto">
                        <div @click="downloadApp('web01windo')"
                             class="pa-3"
                             style="border-radius: 10px; cursor: pointer;"
                             v-ripple
                        >
                            <v-img contain
                                   height="80"
                                   src="/img/icons/platforms/windows.svg"
                                   width="80"
                            ></v-img>
                        </div>
                        <div class="text-center mt-3">Windows</div>
                    </v-col>
                    <v-col class="mx-2" cols="auto">
                        <div @click="downloadApp('web01linux')"
                             class="pa-3"
                             style="border-radius: 10px; cursor: pointer;"
                             v-ripple
                        >
                            <v-img contain
                                   height="80"
                                   src="/img/icons/platforms/linux.svg"
                                   width="80"
                            ></v-img>
                        </div>
                        <div class="text-center mt-3">Linux</div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {osName} from 'mobile-device-detect';
    import SystemHeader from "../SystemHeader";

    export default {
        components: {
            SystemHeader
        },
        name: "browser-not-supported",
        methods: {
            goTo(url) {
                window.open(url, '_blank');
            },
            isOnMac() {
                return osName.toLowerCase() === 'mac os';
            },
            downloadApp(platformid) {
                this.$http.get(`platforms/${platformid}/downloadlatestbinary`).then(
                    (resp) => {
                        window.open(resp.data, '_blank');
                    },
                    (err) => {
                        console.log(err);
                    }
                );
            }
        }
    }
</script>

<style scoped>

</style>